import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router';

import SuspenseLoader from 'src/components/SuspenseLoader';
import registerModulesWithRouter from 'src/config/AccessControl/registerModulesWithRouter';
import DeviceModules from 'src/content/management/Devices/module';
import MaterialAllocationModules from 'src/content/management/MaterialAllocation/module';
import OTAModules from 'src/content/management/OTA/module';
import PDILogsModules from 'src/content/management/PDILogs/module';
import ReturnModules from 'src/content/management/Return/module';
import ServiceModules from 'src/content/management/Service/module';
import DepartmentModules from 'src/content/management/Department/module';
import AlertModules from 'src/content/management/Alert/module';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Dashboard = Loader(
  lazy(() => import('src/content/dashboards/CentralDashboard'))
);

const ChangePassword = Loader(
  lazy(() => import('src/content/management/ChangePassword'))
);

// const TermsOfUse = Loader(lazy(() => import('src/TermsOfUse')));
// const PrivacyPage = Loader(lazy(() => import('src/PrivacyPage')));

const dashboardsRoutes = [
  {
    path: '/',
    element: <Navigate to="/dashboard" />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  // {
  //   path: '/dashboardv2',
  //   element: <Dashboard />
  // },
  // {
  //   path: '/fleet-dashboard',
  //   element: <FleetDashboard />
  // },
  // // {
  // //   path: '/fitmentRecords',
  // //   element: <FitmentRecords />
  // // },
  // {
  //   path: '/vehicle-status',
  //   element: <VehicleStatusDashboard />
  // },
  // registerModulesWithRouter(FSLiveTrackingModules),

  // // {
  // //   path: '/term-of-use',
  // //   element: <TermsOfUse />
  // // },
  // // {
  // //   path: '/privacy',
  // //   element: <PrivacyPage />
  // // },
  // {
  //   path: '/fitment',
  //   element: <Activation />
  // },
  // {
  //   path: '/fitment/add',
  //   element: <AddActivation />
  // },
  // {
  //   path: '/fitment/edit/:id',
  //   element: <ActivationForm />
  // },
  // {
  //   path: 'sim-activation-order',
  //   element: <SimActivationOrder />
  // },
  // {
  //   path: 'sim-activation-order/add',
  //   element: <SimActivationOrderForm />
  // },
  // {
  //   path: 'sim-activation-order/edit/:id',
  //   element: <SimActivationOrderForm />
  // },
  {
    path: 'change-password',
    element: <ChangePassword />
  },
  // registerModulesWithRouter(OrderModules),
  registerModulesWithRouter(OTAModules),
  registerModulesWithRouter(PDILogsModules),
  registerModulesWithRouter(ServiceModules),
  registerModulesWithRouter(DeviceModules),
  registerModulesWithRouter(MaterialAllocationModules),
  registerModulesWithRouter(ReturnModules),
  registerModulesWithRouter(DepartmentModules),
  registerModulesWithRouter(AlertModules),
];

export default dashboardsRoutes;
